import _ from "lodash";
import { axiosInstance } from "./globals";

import {DataSourceRequest} from "@/model/DataSourceRequest";
import {DataSourceResult} from "@/model/DataSourceResult";
import {AdminFilter} from "@/model/filters";
import * as userService from "./userService";


export async function getCurrent() {
  return (await axiosInstance.get("/AppNames/Info", {
    params: {
      domain: location.hostname
    }
  })).data;
}


export async function getCustomerApp() {
  return (await axiosInstance.get("/AppNames/CustomerApp", {
    headers: userService.getAuthHeaders()
  })).data;
}


export async function getAll(filter: AdminFilter): Promise<DataSourceResult<any>> {
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
  };

  if (filter.q) {
    body.filters = [
      { field: "name", operator: "contains", value: filter.q, logic: "or" },
      { field: "domainName", operator: "contains", value: filter.q, logic: "or" },
      // { field: "customerName", operator: "contains", value: filter.q, logic: "or" },
    ];
  }

  return (await axiosInstance.post("/AppNames/List", body, {
    headers: userService.getAuthHeaders()
  })).data;
}

export async function create(body) {
  return (await axiosInstance.post("/AppNames/Create", body, {
    headers: userService.getAuthHeaders()
  })).data;
}


export async function update(body) {
  return (await axiosInstance.post("/AppNames/Update", body, {
    headers: userService.getAuthHeaders()
  })).data;
}


export async function updateCustomerApp(body) {
  return (await axiosInstance.post("/AppNames/UpdateCustomerApp", body, {
    headers: userService.getAuthHeaders()
  })).data;
}


export async function del(id: number) {
  return (await axiosInstance.post(`/AppNames/Delete/${id}`, {}, {
    headers: userService.getAuthHeaders()
  })).data;
}
